import { ContactList } from 'ui/components';

export const ContactListFeature: React.FC<Umbraco.ContactList> = ({ content }) => {
	return <ContactList {...content?.properties} />;
};
